import React from 'react';
import { withApollo } from "react-apollo";

import { notes } from '../../graphql/queries';
import { addNote } from '../../graphql/mutations';
import { ColHead } from '../chunk'


class NoteAdd extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			id: null,
			body: ''
		};

		this.timeout = null;

    	this.handleChange = this.handleChange.bind(this);
    	this.mutate = this.mutate.bind(this);
	}

	componentDidMount(){
	   this.textarea.focus(); 
	}

	handleChange(e) {

		this.setState({ body: e.target.value });
		clearTimeout(this.timeout);

		if(this.state.id === null && this.state.body !== '') {
			this.timeout = setTimeout(this.mutate,  250);
		}
	}

	mutate() {
		const qlVars = {
			body: this.state.body
		}
		this.props.client.mutate({
			mutation: addNote,
			variables: qlVars,
			refetchQueries: [{query: notes}]
		})
		.then(res => {
			const id = res.data.addNote.id;
			this.setState({ id: id });
			this.props.history.replace(`/notes/${id}`);
		})
		.catch(e => {
			alert('Note Error: ' + e);
		});
	}
	
	render() {

		return (
      		<div className="col col-2">
            <ColHead icon="sticky-note" title="NEW NOTE" meta="still a bit buggy" />
		        <textarea className="noteTextarea" 
      				ref={(input) => { this.textarea = input; }} 
	      			value={this.state.body} placeholder="..."
	      			onChange={this.handleChange}></textarea>
      		</div>
      	)
	}
}

export default withApollo(NoteAdd)


// WEBPACK FOOTER //
// ./src/components/note/NoteAdd.js